import "./ErrorText.css"

export default function ErrorText({text}) {
    return (
        <div className="error">
            <strong className='Danger'>{text}</strong>
        </div>
    )
}